import React from 'react';
import Md from 'react-markdown';

export default function Disclaimer({ content }) {
  if (!content) return null;

  return (
    <section className="bg-stone">
      <div className="max-w-[1680px] mx-auto pt-12 pb-8 px-10 text-[16px] leading-5">
        {content.startsWith('<p><strong>Disclaimer:') ? null : (
          <strong className="block mb-1">Disclaimer:</strong>
        )}
        <div dangerouslySetInnerHTML={{ __html: content }}></div>
      </div>
    </section>
  );
}
